import React from 'react';
import Odd from '../../common/Odd';
import { SERVING_SPORTS } from '../../data/constants';
import { getBetDescription } from '../../data/utils/getBetDescription';
import { getNumberOfColsMobile } from '../../data/utils/getNumberOfColsMobile';
import PartialScores from './PartialScores';
import { TournamentContext } from './TournamentDataFetcher';

function TournamentLiveMatch(props) {
    const tournamentContext = React.useContext(TournamentContext);

    const match = props.match;
    const bets = match.bets;
    let betsList = bets;
    betsList = tournamentContext.expanded ? bets : [bets[0]];
    // betsList = filtraParametriche(betsList);

    const score = props.match.score;
    const totalScore = score.formattedScores.find(sc => sc.isTotalScore);

    return (
        <div className="avvenimento">
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <>
                <div className="info-avvenimento-live" href="#" onClick={() => props.openLiveMatch(match)}>
                    <div className="info-base">
                        <div className="badge-live mr-2"></div>
                        <div className="nome-avvenimento">
                            {SERVING_SPORTS.includes(match.sportRef) ?
                                <>
                                    <span className={match.score.srv === 1 ? "text-small service active" : "text-small service"}>{match.team1}</span>
                                    <span className={match.score.srv === 2 ? "text-small service active" : "text-small service"}>{match.team2}</span>
                                </>
                                :
                                <>
                                    <span className="text-small">{match.team1}</span>
                                    <span className="text-small">{match.team2}</span>
                                </>
                            }
                        </div>
                        <div className="info-match push-right">
                            <span className="current-period text-small push-right">{score.periodo} {score.currentMinute ? `(${score.currentMinute})` : ''}</span>
                            <PartialScores scores={match.score.formattedScores} />
                        </div>
                        {totalScore &&
                            <div className="info-score">
                                <span className="text-small">{totalScore.s1}</span>
                                <span className="text-small">{totalScore.s2}</span>
                            </div>
                        }
                    </div>
                </div>
                {betsList.map((bet, i) => {
                    {/* if (bet.parametrica) {
                        return (
                            <React.Fragment key={bet.id}>
                                <div className="label-desc-scom-vista-estesa">{bet.desc}</div>
                                <HandicapSelectorBet bets={match.betsById.get(bet.id)} />
                            </React.Fragment>
                        );
                    } */}

                    return (
                        <React.Fragment key={i}>
                            {tournamentContext.expanded &&
                                <div className="label-desc-scom-vista-estesa">{getBetDescription(bet, true)}</div>
                            }
                            <div className={"esiti-container grid-columns-" + getNumberOfColsMobile(bet.odds.length)}>
                                {bet.odds.map(odd => {
                                    const id = `${odd.matchData.uniqueId}_${odd.betData.id}_${odd.betData.handicap}_${odd.id}`;
                                    return <Odd key={id} {...odd} matchData={props.match} />;
                                })}
                            </div>
                        </React.Fragment>
                    )
                })}
            </>
        </div>
    );
}

export default TournamentLiveMatch;